<template>
  <nav class="navbar min-w-1400">
    <div class="secondBox max-w-1400">
      <div class="logo">
        <img
          :src="require('@/page/nathcopay/components/img/logo.png')"
          :alt="logo"
          class="logoImg"
        />
        <span class="title">NA TECHNOLOGY COMPANY LIMITED</span>
      </div>
      <ul class="nav-links">
        <li :class="{ 'active-link': isActive('/') }" class="Li1">
          <router-link to="/" class="nav-link1">
            <span class="routeText1">Trang chủ</span>
          </router-link>
        </li>
        <li
          :class="{ 'active-link': $route.path === '/questions' }"
          class="Li2"
        >
          <router-link to="/questions" class="nav-link2">
            <span class="routeText2">Hỏi đáp</span>
          </router-link>
        </li>
        <li :class="{ 'active-link': $route.path === '/protocol' }" class="Li3">
          <!-- <router-link to="/protocol" class="nav-link3">
            <span class="routeText3">Điều khoản sử dụng</span>
          </router-link> -->
          <a href="https://policy.nathcovay.nathcopay.com/help/privacy_agreement" class="nav-link3" target="_blank">
            <span class="routeText3">Điều khoản sử dụng</span>
          </a>
        </li>
        <!-- <li
          :class="{ 'active-link': $route.path === '/protocol' }"
          class="Li4"
        >
          <router-link to="/protocol" class="nav-link4">
            <span class="routeText4">ACUERDO DE PRIVACIDAD</span>
          </router-link>
        </li> -->
      </ul>
    </div>
    <!-- <div style="height: 130px"></div> -->
  </nav>
</template>

<script>
export default {
  data() {
    return {
      link1Color: "white",
    };
  },
  methods: {
    isActive(route) {
      return this.$route.path === route;
    },
  },
};
</script>
<style scoped>
.navbar {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: #fff;
}

.secondBox {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 130px;
  padding: 0 15px;
}

.logo {
  font-weight: bold;
  color: black;
  display: flex;
  align-items: center;
}

.logoImg {
  width: 60px;
  height: 60px;
  margin-left: 30px;
}

.title {
  width: 500px;
  height: 24px;
  font-size: 18px;
  font-family: DM Sans-Bold;
  font-weight: 600;
  color: #000000;
  line-height: 23px;
  padding-left: 17px;
  text-transform: uppercase;
}

.routeText1,
.routeText2,
.routeText3,
.routeText4,
.routeText5 {
  font-size: 16px;
  font-family: SF Pro-Semibold;
  font-weight: 550;
  color: #000000;
  line-height: 29px;
  text-transform: uppercase;
}

/* .routeText1 {
  width: 85px;
}

.routeText2 {
  width: 158px;
}

.routeText3 {
  width: 160px;
} */

/* .routeText4 {
  width: 160px;
  text-align: center;
}
.routeText5 {
  width: 160px;
  text-align: center;
} */

.nav-link1,
.nav-link2,
.nav-link3,
.nav-link4,
.nav-link5 {
  text-decoration: none;
  margin: 0 auto;
  text-align: center;
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  /* 垂直居中对齐 */
  justify-content: center;
  /* 水平居中对齐 */
}

.nav-links li {
  display: flex;
  padding: 6px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 39px;
  padding-left: 4px;
  padding-right: 4px;
}
.Li1 {
  width: 130px;
}
.Li2 {
  width: 130px;
}
.Li3 {
  width: 250px;
}
/* 这个如果给margin-right底部可能会出现边距的问题 */
/* .Li4 {
  width: 250px;
  
} */

.active-link {
  /* border-color: #018B11; */
  background-color: #2e7bf7;
  border-radius: 10px;
}

.active-link .routeText1,
.active-link .routeText2,
.active-link .routeText3,
.active-link .routeText4,
.active-link .routeText5 {
  font-family: Inter-Extra Bold;

  color: #ffffff;
}
</style>